"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const ClinicalTrialsEntry = ({ clinicalTrial }) => {
    const { official_title, brief_title, authority } = clinicalTrial;
    const trialsTitle = brief_title || official_title;
    const trialsSubtitle = authority;
    return (react_1.default.createElement(styles_1.ExpertiseEntryContainer, { itemProp: "hasCredential", itemScope: true, itemType: "https://schema.org/MedicalTrial" },
        react_1.default.createElement(styles_1.ExpertiseEntryHeader, { itemProp: "about" }, trialsTitle),
        react_1.default.createElement(styles_1.ExpertiseEntryCopy, null, trialsSubtitle)));
};
exports.default = ClinicalTrialsEntry;
//# sourceMappingURL=clinical-trials-entry.js.map